import React from 'react';  
import './index.css';
import { Badge,WingBlank, WhiteSpace } from 'antd-mobile';
import TopicIcon from './img/icon_topic.png';
import NoContent from 'component/noContent';
import TopicBottom from '.././topicBottom' 
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseLiveStore';
 class TopicAnswer extends React.Component{
  render(){
    const {data} =this.props;
    return(
        <div className="topic-answer-wrapper">
          <div className="answer-text">
            <span className="answer-name">{data.get('user_name')?data.get('user_name'):null}:</span>
            <span>{data.get('content')?data.get('content'):null}</span>
          </div>
        </div>
      )
  }
}
 class Bottom extends React.Component{
  render(){
    const {time} = this.props
    return(
      <div className="topic-bottom-wrapper">
        <div className="topic_icon" >
          <img src={TopicIcon} alt=""/>
        </div>
        <div>
          {time?time:'暂无'}
        </div>
        
      </div>
      )
  }
 }
class TopicItem extends React.Component{
 
  itemClick(e,id){
    this.props.comment(e,id) 
  } 

  render(){
    const {item} = this.props; 
    return(
        <div className="inter-item-wrapper" onClick={(e)=>{this.itemClick(e,item.get('id'))}}>
          <WhiteSpace/>
          <div className="topic-ask-wrapper">
            <Badge className="ask-badge" text="话题" />
            <div>
              <span>{item.get('title')?item.get('title'):null}</span>
            </div>
          </div>
          <WhiteSpace/>
          {
            item.get('chat')&&item.get('chat').size!=0?
            item.get('chat').map((i,index)=>{
              return(<TopicAnswer key={i} data={i}/>)
            }):
            null
          }
          <Bottom time={item.get('created_at')} />
          
        </div> 
    )
  }
}
class TabTopic extends React.Component{
  render(){
    const { list } = this.props;
    return (
      <div className="tab-topic">
          <div className="topic-wrapper">
          {
            list&&list.size!=0?
            list.map((item,index)=>{
              return (<TopicItem 
                        key={index}
                        item={item}  
                        comment={(e,topic_id)=>{this.props.topicClick(e,topic_id)}}/>)
            }):
            <NoContent/>
          }
          </div>
      </div>
      )
  }
}
 


const mapState = (state) => ({
     
})

const mapDispatch = (dispatch) => ({
    
})
export default connect(mapState, mapDispatch)(TabTopic);